<template lang="html">
  <div v-if="isLoading"></div>
  <div v-else>

  <!-- <meta charset="utf-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <meta property="og:title" content="NerzExpress" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://ex.nerz.jp" />
  <meta property="og:image" content="https://ex.nerz.jp/img/ogp-image.png" />
  <meta property="og:site_name" content="NerzExpress" />
  <meta property="og:description" content="NerzExpress is a service that connects you to fellow otaku in Japan. You will be able to engage with these otaku in various ways such as purchasing owned items directly from them or negotiating terms with them to purchase items for you when they attend various events!" />
  <meta name="twitter:card" content="summary_large_image"> -->
  <link rel="icon" href="https://ex.nerz.jp/img/favicon.png">

  <div class="fixed-btn">
    <router-link to="/login">
      <btn size="normal" type="primary" label="Sign up or Login"></btn>
    </router-link>
  </div>

  <div class="content">
    <div class="header-wrapper">
      <div class="header bg-yayoi">
        <div class="logo">
          <img src="../../../assets/img/logo.svg">
          <p class="logo-subtitle w4 color-yukiho">Unlimited Proxy Works</p>
          <router-link tag="div" to="/login" class="m-t-20 pc">
            <btn size="normal" type="white" label="Login" style="border: none;"></btn>
          </router-link>
        </div>
        <div class="nazuna-top">
          <img src="../../../assets/img/nazuna-top.png">
        </div>
        <div class="arrow arrow-down arrow-1" style="bottom: -22vh;"></div>
        <div class="arrow arrow-down arrow-2" style="bottom: -25vh;"></div>
        <div class="arrow arrow-down arrow-3" style="bottom: -28vh;"></div>
      </div>
    </div>

    <router-link tag="div" to="/login" id="join-button" class="join-button bg-yayoi">
      <btn size="normal" type="primary" label="Login"></btn>
    </router-link>

    <div class="about-nerzex section">
      <div class="ex-title anim-left" data-delighter>
        <div class="ex-title-nazuna ex-title-1"></div>
        <div class="ex-title-cover"></div>
        <div class="ex-title-line"></div>
        <p class="color-yukiho w6">How the service was Established</p>
      </div>

      <fade-in :default="isSpawn">
        <p class="history-message">
          Enabling the best otaku life anywhere in the world
        </p>
      </fade-in>
      <fade-in :default="isSpawn2">
        <div class="history">
          <p>This service was created by ascertaining the needs of media fans who introduced anime related events, illustrators, and cosplayers in Japan, which were used for English-speaking countries.</p>
          <p>We founded our business to contribute to the world so that anyone can touch their favorite content wherever and whenever they want.</p>
          <p>The name "Uniting Borderless World" comes from this meaning.</p>
        </div>
      </fade-in>

      <div class="solution">
        <fade-in>
          <div class="solution-title">
            <p>What is NerzExpress</p>
          </div>
        </fade-in>
        <div class="service-flow">
          <!-- <p class="service-flow-title"> Service Flow</p> -->
          <fade-in>
            <img src="../../../assets/img/howto1-en.png">
          </fade-in>
          <fade-in>
            <img src="../../../assets/img/howto2-en.png">
          </fade-in>
          <fade-in>
            <img src="../../../assets/img/howto3-en.png">
          </fade-in>
        </div>
      </div>
    </div>

    <div class="easy-of-use section">
      <fade-in>
        <div class="ex-title ex-title-reverse anim-right" data-delighter>
          <div class="ex-title-nazuna ex-title-nazuna-reverse ex-title-2"></div>
          <div class="ex-title-cover ex-title-cover-reverse"></div>
          <div class="ex-title-line ex-title-line-reverse"></div>
          <p class="color-yukiho w6">Users Voice</p>
        </div>
      </fade-in>
      <fade-in>
        <div class="happy-wrapper">
          <div class="happy-content">
            <div class="happy-photo" style="background-image: url('https://pbs.twimg.com/media/ELI7HR2UEAAOysy?format=jpg&name=medium');"></div>
            <p class="happy-text">
              <a class="user-name" href="https://twitter.com/0GeeMI/status/1203089080205996032">@0GeeMI</a>
              My order from http://ex.nerz.jp came in today! Great website if you're looking to get limited items from Japan! Thanks @nerz_jp
            </p>
          </div>
          <div class="happy-content">
            <div class="happy-photo" style="background-image: url('https://pbs.twimg.com/media/ENqrOvpU4AA6rpX?format=jpg&name=medium');"></div>
            <p class="happy-text">
              <a class="user-name" href="https://twitter.com/dollmiraceti/status/1214471329975394306">@dollmiraceti</a>
              Got my special New Years Precure Pretty Store bag from @nerz_jp
              I'm so happy aaaaa!! The blanket is so soft, and my wife is so beautiful. Please use their service, I highly recommend it if you want limited goods.
            </p>
          </div>
        </div>
      </fade-in>
    </div>

    <div class="provide-fb section">
      <fade-in>
        <div class="ex-title anim-left" data-delighter>
          <div class="ex-title-nazuna ex-title-3"></div>
          <div class="ex-title-cover"></div>
          <div class="ex-title-line"></div>
          <p class="color-yukiho w6">Request List/Market List</p>
        </div>
      </fade-in>
      <fade-in>
        <div class="products">
          <div class="product-wrapper" v-for="(val, key) in requests">
            <div class="request-img" :style="`background-image:url(${val.img1})`">
              <p class="request-price">{{val.price}} JPY</p>
            </div>
            <div class="request-name-wrapper">
              <p class="request-name">{{val.name}}</p>
            </div>
          </div>
          <div class="product-wrapper" v-for="(val, key) in items">
            <div class="request-img" :style="`background-image:url(${val.img1})`">
              <p class="request-price">{{val.price}} JPY</p>
            </div>
            <div class="request-name-wrapper">
              <p class="request-name">{{val.name}}</p>
            </div>
          </div>
        </div>
      </fade-in>
    </div>

    <div class="about-nazuna section">
      <fade-in>
        <div class="ex-title ex-title-reverse anim-right" data-delighter>
          <div class="ex-title-nazuna ex-title-nazuna-reverse ex-title-4"></div>
          <div class="ex-title-cover ex-title-cover-reverse"></div>
          <div class="ex-title-line ex-title-line-reverse"></div>
          <p class="color-yukiho w6">Frequently asked questions</p>
        </div>
      </fade-in>

      <fade-in>
        <nav class="accordion arrows">
          <input type="radio" name="accordion" id="cb1" />
          <section class="box">
            <label class="box-title" for="cb1">Which countries do you support?</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              <img class="answer-nazuna"src="../../../assets/img/def.png" alt="">
              <p>Countries that accepts payments are,</p>
              <p>Ireland, United Kingdom, Italy, India, Estonia, Netherlands, Australia, Austria, Canada, Greece, Singapore, Switzerland, Sweden,
   Spain, Slovakia, Slovenia, Denmark, Germany, New Zealand, Norway, Finland, France, Belgium, Portugal, Poland, Malaysia, Mexico,
   Latvia, Lithuania, Luxembourg, Japan, USA, Hong Kong</p>
              <p>In particular, we are currently using Stripe for payment, however we would like to support G Cash etc in the future.</p>
            </div>
          </section>
          <input type="radio" name="accordion" id="cb2" />
          <section class="box">
            <label class="box-title" for="cb2">Is there a usage fee?</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              <img class="answer-nazuna"src="../../../assets/img/def.png" alt="">
              <p>There is no usage fee upon using the platform! There are no sales fees, but there are payment and payment fees for payment services.</p>
            </div>
          </section>
          <input type="radio" name="accordion" id="cb3" />
          <section class="box">
            <label class="box-title" for="cb3">Can I use this even though I can't speak Japanese?</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              <img class="answer-nazuna"src="../../../assets/img/def.png" alt="">
              <p>No problem since the service can be used in English, however transactions may be in Japanese, so please use translations etc.</p>
              <p>in that case! We are preparing a fixed form for transactions and are preparing to translate it into each language, so please wait for the update!</p>
            </div>
          </section>
          <input type="radio" name="accordion" id="cb4" />
          <section class="box">
            <label class="box-title" for="cb4">What are the benefits of responding to requests?</label>
            <label class="box-close" for="acc-close"></label>
            <div class="box-content">
              <img class="answer-nazuna"src="../../../assets/img/def.png" alt="">
              <p>When you respond to your request, your account will continue to grow! Highly rated users are more likely to be trusted, and in the future, we are thinking of giving preferential treatment to highly rated users!</p>
              <p>In addition, at the moment, if you respond to the request, you will receive a separate reward (tips)!</p>
            </div>
          </section>

          <input type="radio" name="accordion" id="acc-close" />
        </nav>
      </fade-in>
    </div>

    <div class="about-nazuna section">
      <fade-in>
        <div class="ex-title anim-left" data-delighter>
          <div class="ex-title-5"></div>
          <div class="ex-title-cover"></div>
          <div class="ex-title-line"></div>
          <p class="color-yukiho w6">Announcements</p>
        </div>
      </fade-in>
      <fade-in>
        <div class="news">
          <div class="news-content">
            <p class="news-date">
              2019.11.3
            </p>
            <p class="news-text"></p>
            <a class="news-title" href="/"><p>Service released</p></a>
          </div>
          <div class="news-content">
            <p class="news-date">
              2019.12.24
            </p>
            <p class="news-text"></p>
            <a class="news-title" href="https://ubw.co.jp"><p>Established UBW Co., Ltd. Changed management from an individual to a corporation.</p></a>
          </div>
        </div>
      </fade-in>
    </div>

    <div class="about-nazuna section">
      <fade-in>
        <div class="ex-title ex-title-reverse anim-right" data-delighter>
          <div class="ex-title-6"></div>
          <div class="ex-title-cover ex-title-cover-reverse"></div>
          <div class="ex-title-line ex-title-line-reverse"></div>
          <p class="color-yukiho w6">Open Recruitment</p>
        </div>
      </fade-in>
      <fade-in>
        <div class="banner-text">
          <p>Currently, in UBW Co., Ltd., we are looking for friends who can make a better otaku life together.</p>
          <p>Please feel free to contact us as we can discuss side jobs, outsourcing, part-time jobs, internships, etc.</p>
        </div>
      </fade-in>
      <div class="banner-flex">
        <fade-in>
          <div class="banner">
            <a href="mailto:info@nerz.jp">
              <img src="../../../assets/img/engineer-banner.png">
            </a>
          </div>
        </fade-in>
        <fade-in>
        <div class="banner">
          <a href="mailto:info@nerz.jp">
            <img src="../../../assets/img/business-banner.png">
          </a>
        </div>
        </fade-in>
      </div>
    </div>


    <div class="footer color-yukiho">
      <p>Operating company：<a href="https://ubw.co.jp">UBW, inc.</a></p>
      <p><a href="/terms-of-service">Terms of service</a></p>
      <p><a href="/privacy-policy">Privacy policy</a></p>
      <p>©2020 Nerz Powerd by https://nerz.jp</p>
    </div>
    <!-- content end -->
  </div>

  <!-- <div class="modal">
    <div class="form-area">
      <p class="modal-title color-yukiho">Please input your data</p>
      <div class="form-item">
        <input type="text" class="email-data" placeholder="email">
      </div>
      <div class="form-item">
        <input type="text" class="name-data" placeholder="Nickname">
      </div>
      <div class="form-item">
        <input type="text" class="friendcode-data" placeholder="Friend code (if you have)">
      </div>
      <div class="button bg-yayoi color-yukiho" onclick="sendData()" >Register</div>
      <p class="error-text"></p>
    </div>
    <div class="modal-thanks" onclick="closeModal()">
      <p class="thanks-text">Thanks for the pre-register!! Go check the mail I've just sent you and gain the discount coupon!!</p>
      <div class="thanks-img">
        <img src="../../assets/img/nazuna-wink.png">
      </div>
    </div>
    <div class="loading">
      <div>
        <img src="../../assets/img/puff.svg" />
      </div>
    </div>
    <div class="modal-back" onclick="closeModal()"></div>
  </div> -->
</div>

</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=UA-128988234-1"></script>
<script
  src="https://code.jquery.com/jquery-3.3.1.min.js"
  integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8="
  crossorigin="anonymous">
</script>
<script src="../js/delighters.min.js"></script>
<script>

 window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-128988234-1');
</script>

<script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>

<script>
import axios from 'axios'
import Btn from '../../../components/Button.vue'
import FadeIn from '../../../components/FadeIn.vue'

export default {
  name: 'NerzExpress',

  components: {
    Btn,
    FadeIn,
  },

  data() {
    return {
      requests: [],
      items: [],
      isSpawn: false,
      isSpawn2: false,
      isLoading: true,
    };
  },

  mounted() {
    let langGet = navigator.language
    if(langGet === "ja") {
      this.$router.push("/")
    }
    axios.get('public/get_requests').then((data)=> {
      this.requests = data.data.model.reverse()
    }).catch((err) => {
      console.log(err)
    })
    axios.get('public/get_items').then((data)=> {
      this.items = data.data.model.reverse()
    }).catch((err) => {
      console.log(err)
    })

    if(window.outerHeight > 995) {
      this.isSpawn = true
    }
    if(window.outerHeight > 1385) {
      this.isSpawn2 = true
    }

    this.isLoading = false
  },
}
</script>

<style src="../css/reset.css"></style>
<style src="../css/layout.css"></style>
<style src="../css/common.css"></style>
<style src="../css/about.css"></style>
<style src="../css/aboutnazuna.css"></style>
<style src="../css/anime.css"></style>
<style src="../css/card.css"></style>
<style src="../css/feedback.css"></style>
<style src="../css/header.css"></style>
<style src="../css/modal.css"></style>
<style src="../css/point.css"></style>
<style src="../css/title.css"></style>
<style src="../css/product.css"></style>
<style src="../css/question.css"></style>
<style src="../css/news.css"></style>
<style src="../css/banner.css"></style>
<style src="../css/happy.css"></style>
